var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-avatar--wrapper",style:([_vm.style, _vm.customStyle]),attrs:{"aria-hidden":"true"}},[(this.isImage)?_c('img',{staticStyle:{"display":"none"},attrs:{"src":this.src},on:{"error":_vm.onImgError}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!this.isImage),expression:"!this.isImage"}]},[_vm._v(_vm._s(_vm.userInitial))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8062f09e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edAvatar/index.vue
// module id = aC/2
// module chunks = 12